import { render, staticRenderFns } from "./SurveyTypeListAddNew.vue?vue&type=template&id=5eed4a56&"
import script from "./SurveyTypeListAddNew.vue?vue&type=script&lang=js&"
export * from "./SurveyTypeListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./SurveyTypeListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports